export default __webpack_public_path__ + "static/media/slider5.9b1bc7ca.jpg";